export const PAGES_TO_HIDE_SAVE = [
    "myAccount",
    "dashboard",
    "mydashboard",
    "myteamsdashboard",
    "completedTasks",
    "myOpenTasks",
    "mktComponents",
    "settings",
    "roles",
    "appsMainPage",
    "YourApplications",
    "SharedApplications",
    "AddToArchive",
    "reports",
    "messagingAndComm",
    "processInspector",
    "emailTemplates",
    "EmailResponseScreens",
    "statistics",
    "teamsTasks",
    "completedTeamsTasks",
    "ruleTesting",
    "permissions",
    "smartContractList",
    "newSmartContract",
    "Authentication",
    "useTemplate",
    "startFromScratch",
    "dataStoreLegacy",
    "Plugins",
    "appSpecificGroups",
    "globalIntegration",
    "SystemApis",
    "expose",
    "consumed",
    "internalApis",
    "StatusReport",
    "SSLCertificates",
    "accessDenied",
    "export",
    "search",
    "ProcessList",
    "SoftwareLicenses",
    "branding",
    "logs",
    "pageNotFound"
];
